module.exports = __webpack_public_path__ + "static/media/fly0046.74873470.webp";